import React, { Component } from 'react';

class Newsletter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      'name': '',
      'email': '',
      'submitted': false,
    }

  }

  handleChange(evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  submit() {
    if (!this.state.name || !this.state.email) {
      alert('Please enter a name and email');
      return;
    }

    fetch('/newsletter', {
      'method': 'POST',
      'body': JSON.stringify(this.state),
      'headers': {
        'content-type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          this.setState({ 'submitted': true });
        }
      })
      .catch(err => {
        alert('An error occurred submitting your information.');
      })

  }

  render() {
    return (
      <div className="Newsletter">
        <h3>ASHA Newsletter Signup</h3>
        {this.state.submitted === true &&
          <div className="alert alert-success">Thank you your newsletter request has been submitted.</div>
        }
        {this.state.submitted === false &&
          <div className="NewsletterForm">
            <div className="form-group">
              <label>Name</label>
              <input className="form-control" type="text" value={this.state.name} onChange={(evt) => this.handleChange(evt)} name="name" />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input className="form-control" type="email" value={this.state.email} onChange={(evt) => this.handleChange(evt)} name="email" />
            </div>
            <button className="btn btn-default" onClick={(evt) => this.submit(evt)}>Subscribe</button>
          </div>
        }
      </div>
    );
  }
}

export default Newsletter;
